"use client";

import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
function LabValuesConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-64 rounded-xl bg-muted/30 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-sm text-muted-foreground text-center py-12">
        Failed to load lab values. Please try again later.
      </div>;
  }
  if (posts.length === 0) {
    return <p className="text-muted-foreground text-center py-12">No lab values to display.</p>;
  }
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group shadow-soft hover:shadow-medium hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
          <CardHeader>
            <CardTitle className="text-lg font-semibold text-foreground">
              {post.customFields?.name || post.title}
            </CardTitle>
            {post.customFields?.normal_range && <CardDescription className="text-sm text-muted-foreground mt-2">
                Normal Range: {post.customFields.normal_range}
              </CardDescription>}
          </CardHeader>

          {post.customFields?.description && <CardContent>
              <p className="text-sm text-muted-foreground line-clamp-3">
                {post.customFields.description}
              </p>
            </CardContent>}

          <CardFooter>
            {post.link && <Link to={post.link}>
                <Button variant="outline" size="sm" className="group-hover:bg-primary group-hover:text-foreground-primary group-hover:-translate-y-0.5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                  Read More
                  <ArrowRight className="size-4" />
                </Button>
              </Link>}
          </CardFooter>
        </Card>)}
    </div>;
}
export default function PopularLabValues() {
  return <section className="py-16 px-4 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
            Popular Lab Values
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">Explore common laboratory tests and biomarkers. Our educational content is based on clinical guidelines and large medical studies.</p>
        </div>

        <PostsProvider postType="lab_value" wp_query={{
        per_page: 6,
        order: "desc",
        orderby: "date"
      }} embeds={[]} fields={["id", "title.rendered", "link", "meta"]} className="lab-values-grid-wrapper">
          <LabValuesConsumer />
        </PostsProvider>
      </div>
    </section>;
}